import { render, staticRenderFns } from "./privacypolicy.vue?vue&type=template&id=a16e7b5a"
import script from "./privacypolicy.vue?vue&type=script&lang=js"
export * from "./privacypolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports